import Modal from "react-responsive-modal";
import "react-responsive-modal/styles.css";
import { Controller, useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { newModalStyle } from "../../reusable/styles.js";
import LabelWithHR from "../../common/labels/labelWithHR.js";
import Style from "./modalEditTicket.module.css";
import { useState } from "react";
import "react-datepicker/dist/react-datepicker.css";
import { registerLocale } from "react-datepicker";
import de from "date-fns/locale/de";
import Button from "../../common/button/button.js";

import {closeReasons} from "../../globals.js";

registerLocale("de", de);

const ModalCloseTicket = (props) => {
  const { handleSubmit, control } = useForm();
  const [closeTicketReq, setCloseTicketReq] = useState({
    ticketId: props.ticketForEdit?.id,
    closeReason: "",
    justification: ""
  });

  const ticketClose = () => {
    props.closeTicket(closeTicketReq);
    props.close();
  };

  const { t } = useTranslation();
  return (
    <Modal
      open={props.open}
      closeOnEsc
      onClose={props.close}
      center
      styles={newModalStyle({ width: "450px" })}
    >
      <form onSubmit={handleSubmit(ticketClose)}>
        <div className="modal__title">
          {t("ModalCloseTicket.CloseTicket")}
        </div>

        <div>
          <LabelWithHR label={t("ModalCloseTicket.CloseReason")} />
          <Controller
            name="closeReason"
            control={control}
            render={({ field }) => (
                <select
                  {...field}
                  className={Style.textStyleInputEditModal}
                  onChange={(e) => {
                    field.onChange(e); // Update form control
                    setCloseTicketReq({
                      ...closeTicketReq,
                      closeReason: e.target.value,
                    });
                  }}
                  value={closeTicketReq.closeReason}
                >
                <option value="" disabled>
                    {t("ModalCloseTicket.Select")} 
                </option>
                {closeReasons.map((reason) => (
                    <option key={reason.value} value={reason.value}>
                        {t(`CloseReasons.${reason.value}`)} 
                    </option>
                ))}
                </select>
              )}
          />
        </div>
        <div>
          <LabelWithHR label={t("ModalCloseTicket.Justification")} />
          <Controller
            name="justification"
            control={control}
            render={() => (
              <input
                className={Style.textStyleInputEditModal}
                name="justification"
                type="text"
                onChange={(e) => {
                    setCloseTicketReq({
                    ...closeTicketReq,
                    justification: e.target.value,
                  });
                }}
                defaultValue={closeTicketReq.justification}
              />
            )}
          />
        </div>        

        <div className={Style.buttonContainer}>
          <Button
            style={{
              width: "25%",
              marginTop: 30,
            }}
            disabled={false}
            buttonStyle={{
              width: "100%",
            }}
            text={t("ModalCloseTicket.Close")}
          />
        </div>
      </form>
    </Modal>
  );
};
export default ModalCloseTicket;
